// @ts-nocheck

import React from 'react'
import PropTypes from 'prop-types'
import { colors } from '@lmc/common/constants'
import { hexToRgbA } from '../../../common/utils'

/**
Renders an generic banner

@param {string} color. Sets the colour for the banner.
Defaults to colors.informationblue
@param {object} customStyles. A styles object. Can be used
to add additional stylings to the banner or to override the
default stylings, e.g. add weight to the border.
@param {string} text. The banner text
*/

const Banner = (props) => {
  const {
    color = colors.informationblue,
    customStyles, // overrides default stylings
    text,
  } = props

  const bannerStyle = {
    ...styles.banner,
    background: hexToRgbA(color, 0.05),
    border: `1px solid ${hexToRgbA(color, 0.2)}`,
    color,
    ...customStyles,
  }

  return <div style={bannerStyle}>{text}</div>
}

const styles = {
  banner: {
    borderRadius: 4,
    marginTop: 20,
    padding: 13,
    textAlign: 'center',
    width: '100%',
  },
}

Banner.propTypes = {
  color: PropTypes.string,
  customStyles: PropTypes.object,
  text: PropTypes.string.isRequired,
}

export default Banner
